import { render, staticRenderFns } from "./BlowingTab.vue?vue&type=template&id=2faf1eef&scoped=true"
import script from "./BlowingTab.vue?vue&type=script&lang=js"
export * from "./BlowingTab.vue?vue&type=script&lang=js"
import style0 from "./BlowingTab.vue?vue&type=style&index=0&id=2faf1eef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf1eef",
  null
  
)

export default component.exports